import "./JobFilters.css";

import {
  FaSearch,
  FaMapMarkerAlt,
  FaBuilding,
  FaFilter,
  FaTimes,
} from "react-icons/fa";


function JobFilters({

  search = "",
  setSearch = () => {},

  company = "",
  setCompany = () => {},

  location = "",
  setLocation = () => {},

  type = "",
  setType = () => {},

}) {


  const clearFilters = () => {

    setSearch("");

    setCompany("");

    setLocation("");

    setType("");

  };


console.log("JobFilters Rendered");
  return (

    <section className="job_filters_section">


      {/* =========================
              HEADER
      ========================= */}


      <div className="job_filters_header">


        <h2>

          Explore Career Opportunities

        </h2>


        <p>

          Find jobs according to your skills,
          preferred company and location.

        </p>


      </div>




      {/* =========================
              FILTER BOX
      ========================= */}


      <div className="job_filters_container">



        {/* SEARCH */}


        <div className="job_filter_input_box">


          <FaSearch />


          <input

            type="text"

            placeholder="Search job title..."

            value={search}

            onChange={(e)=>

              setSearch(e.target.value)

            }

          />


        </div>





        {/* COMPANY */}


        <div className="job_filter_input_box">


          <FaBuilding />


          <select

            value={company}

            onChange={(e)=>

              setCompany(e.target.value)

            }

          >


            <option value="">

              All Companies

            </option>


            <option value="TCS">

              TCS

            </option>


            <option value="Infosys">

              Infosys

            </option>


            <option value="Wipro">

              Wipro

            </option>


            <option value="Capgemini">

              Capgemini

            </option>


            <option value="Accenture">

              Accenture

            </option>


            <option value="Cognizant">

              Cognizant

            </option>


          </select>


        </div>





        {/* LOCATION */}


        <div className="job_filter_input_box">


          <FaMapMarkerAlt />


          <select


            value={location}


            onChange={(e)=>

              setLocation(e.target.value)

            }


          >


            <option value="">

              All Locations

            </option>


            <option value="Kolkata">

              Kolkata

            </option>


            <option value="Bangalore">

              Bangalore

            </option>


            <option value="Pune">

              Pune

            </option>


            <option value="Hyderabad">

              Hyderabad

            </option>


            <option value="Chennai">

              Chennai

            </option>


            <option value="Noida">

              Noida

            </option>


          </select>


        </div>





        {/* TYPE */}


        <div className="job_filter_input_box">


          <FaFilter />


          <select


            value={type}


            onChange={(e)=>

              setType(e.target.value)

            }


          >


            <option value="">

              All Types

            </option>


            <option value="Full Time">

              Full Time

            </option>


            <option value="Internship">

              Internship

            </option>


            <option value="Remote">

              Remote

            </option>


            <option value="Hybrid">

              Hybrid

            </option>


          </select>


        </div>




        {/* CLEAR BUTTON */}


        <button

          className="job_filter_clear_btn"

          onClick={clearFilters}

        >


          <FaTimes />


          Clear


        </button>



      </div>


    </section>

  );

}


export default JobFilters;